import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=ba8a0ad4"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"
import style0 from "./Billing.vue?vue&type=style&index=0&id=ba8a0ad4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports